module.exports = __webpack_public_path__ + "files/5440d55f5155d00b3e60819c697fab4c.png";